export default __webpack_public_path__ + "static/media/rotating-card-bg-front.bdcdfadc.jpeg";